import { Component } from 'react';
import { connect } from 'react-redux';

import WpToastManager from 'Wpds/components/toast/WpToastManager';

type Props = {
  message: { text: string };
};

class ErrorMessage extends Component<Props> {
  componentDidUpdate() {
    if (this.props.message.text) {
      WpToastManager.danger(this.props.message.text);
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  message: state.errorMessage,
});

export default connect(mapStateToProps)(ErrorMessage);
